import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { PharmacyBase } from './PharmacyBase';
import { User } from './User';

export const PharmacyUser = types.compose(
  'PharmacyUser',
  BaseEntity,
  types
    .model({
      pharmacyId: types.maybe(types.integer),
      userId: types.maybe(types.integer),
      user: User
    })

);
